module.exports = __webpack_public_path__ + "img/lyon_bg.636f6d60.jpg";